import nav from './nav.js'
import home from './home.js'
import mobile from './mobile.js'
import layers from './layers.js'
import sources from './sources.js'
import risk from './risk.js'
import app from './app.js'
import toolbar from './toolbar.js'
import colorPicker from './colorPicker.js'
import legend from './legend.js'
import layerNames from './layerNames.js'

export default {
  nav,
  home,
  mobile,
  layers,
  sources,
  risk,
  app,
  toolbar,
  colorPicker,
  legend,
  layerNames
}
